import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvConfig } from '@digilize/shared/definitions/src';
import { getTranslationSuffix } from '@digilize/shared/utils/helpers/src';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens/src';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  private envConfig: EnvConfig = inject(ENV_CONFIG);
  getTranslation(lang: string) {
    let obs: Observable<any>[] = [];
    const SUFFIX = getTranslationSuffix(this.envConfig);
    const isLazyLoaded = lang.includes('/');

    if (!isLazyLoaded) {
      obs.push(this.http.get<Translation>(`assets/i18n/common/${lang}${SUFFIX}`));
      obs.push(this.http.get<Translation>(`assets/i18n/${lang}${SUFFIX}`));
      obs.push(this.http.get<Translation>(`assets/i18n/common/alerts-${lang}${SUFFIX}`));
    } else {
      obs.push(this.http.get<Translation>(`assets/i18n/modules/${lang}${SUFFIX}`));
    }
    return forkJoin([...obs]).pipe(
      map((translationsArr) => {
        const translations = translationsArr.reduce((acc, curr) => {
          return this.mergeRecursively(acc, curr);
        }, {});
        return translations;
      })
    );
  }

  mergeRecursively(obj1, obj2) {
    const merged = {};

    for (let key in obj1) {
      if (obj1.hasOwnProperty(key)) {
        // If the key exists in both objects and both values are objects, merge them recursively
        if (
          obj2.hasOwnProperty(key) &&
          typeof obj1[key] === 'object' &&
          typeof obj2[key] === 'object' &&
          !Array.isArray(obj1[key]) &&
          !Array.isArray(obj2[key])
        ) {
          merged[key] = this.mergeRecursively(obj1[key], obj2[key]);
        } else if (obj2.hasOwnProperty(key)) {
          // If the key exists in both but not both are objects, take the value from the second object
          merged[key] = obj2[key];
        } else {
          // Otherwise, take the value from the first object
          merged[key] = obj1[key];
        }
      }
    }

    // Add any keys from the second object that aren't in the first object
    for (let key in obj2) {
      if (obj2.hasOwnProperty(key) && !merged.hasOwnProperty(key)) {
        merged[key] = obj2[key];
      }
    }

    return merged;
  }
}
